import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<section class=\'block-list payment-list {{if @payment_method \"payment-selected\"}}\'>\n  <div class=\'payment-detail\'>\n    <span class=\'link-button alert\' {{on \'click\' (fn (mut @payment_method) null)}}>\n      <FaIcon @icon=\'trash-alt\' />\n    </span>\n    {{@payment_method}}\n  </div>\n  <ul class=\'vertical menu action-sheet-scroll-box\'>\n    {{#each this.session.payment_methods as |pm|}}\n      {{#if pm.expand}}\n        <li>\n          <a {{on \'click\' (fn (mut @payment_method) pm.name)}}>\n            <span class=\'pf {{pm.icon}}\'></span>\n            {{pm.name}}\n          </a>\n        </li>\n      {{/if}}\n    {{/each}}\n\n    {{#if this.showMore}}\n      {{#each this.session.payment_methods as |pm|}}\n        {{#unless pm.expand}}\n          <li>\n            <a {{on \'click\' (fn (mut @payment_method) pm.name)}}>\n              <span class=\'pf {{pm.icon}}\'></span>\n              {{pm.name}}\n            </a>\n          </li>\n        {{/unless}}\n      {{/each}}\n    {{/if}}\n\n    <li class=\'text-center\'>\n      <a {{on \'click\' (fn (mut this.showMore) (if this.showMore false true))}}>\n        {{t \'show more\'}}\n      </a>\n    </li>\n  </ul>\n</section>");

var _class, _descriptor, _descriptor2;
let BbPaymentsListComponent = (_class = class BbPaymentsListComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    // [regression-fix] showMore was reactive via Classic's set(); Glimmer requires @tracked for template re-renders
    _initializerDefineProperty(this, "showMore", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showMore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
setComponentTemplate(TEMPLATE, BbPaymentsListComponent);

export { BbPaymentsListComponent as default };
//# sourceMappingURL=bb-payments-list.js.map
